import useAxios from "src/core/shared/hooks/useAxios";

import {
  EndpointConfig,
  RequestConfig,
  UseApiRequest
} from "../../api/config.api";

export type S3LinkParams = { key: string; };
export type S3URL = { signedUrl: string };

export type ListS3LinkParams = { keys: string[] };
export type ListS3URL = { signedUrls: string[] };

type S3EndpointConfig = {
  GET_PRESIGNED_URL: EndpointConfig<
  S3LinkParams,
  S3URL
  >;
  LIST_PRESIGNED_URLS: EndpointConfig<
  ListS3LinkParams,
  ListS3URL
  >;
};

const BASE_URL = `${process.env.REACT_APP_API_URL}/core`;

const requests: RequestConfig<S3EndpointConfig> = {
  GET_PRESIGNED_URL: ({ key }) => ({
    url: `${BASE_URL}/document/signedURL/${key}`,
    method: "GET"
  }),
  LIST_PRESIGNED_URLS: ({ keys }) => ({
    url: `${BASE_URL}/document/signedURLs`,
    method: "GET",
    params: { keys: keys.join(",") }
  })
};

export const useS3Api: UseApiRequest<S3EndpointConfig> = name => useAxios(requests[ name ], name);
